import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { PRICE, REGULAR_PRICE } from '../data/valueStack';
import { CtaButton } from './CtaButton';
type InlineCtaTone = 'night' | 'night-900' | 'wine-dark';
interface InlineCtaProps {
  label: string;
  /** Matches the background of the section this button sits under. */
  tone?: InlineCtaTone;
}
const toneClasses: Record<InlineCtaTone, string> = {
  night: 'bg-night',
  'night-900': 'bg-night-900',
  'wine-dark': 'bg-wine-dark'
};

/** Buy button placed at the end of a section, straight to checkout. */
export function InlineCta({
  label,
  tone = 'night'
}: InlineCtaProps) {
  return <div className={`${toneClasses[tone]} -mt-4 pb-16 sm:-mt-8 sm:pb-24`} data-id="element-212" data-mp="2li1v3re82egw">
      <div className="mx-auto flex max-w-shell flex-col items-center gap-3 px-5 text-center sm:px-6" data-id="element-213" data-mp="2pl80yxxfa3mu">
        <CtaButton size="lg" data-id="element-214" data-mp="r7pxflu9snin">{label}</CtaButton>
        <p className="text-xs text-amber-light" data-id="element-215" data-mp="v7gs40mx3nsg">
          Tylko {PRICE} dzisiaj <span className="text-cream-muted line-through" data-id="element-216" data-mp="v9tcekg5ea8o">{REGULAR_PRICE}</span>
        </p>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[11px] text-cream-muted" data-id="element-217" data-mp="300029kav6mzi">
          <span className="flex items-center gap-1.5" data-id="element-218" data-mp="2v53yjmw9mb6k">
            <LockIcon className="h-3 w-3 text-amber" aria-hidden="true" data-id="element-219" data-mp="2q95g0fxmbne2" /> Bezpieczna płatność
          </span>
          <span className="flex items-center gap-1.5" data-id="element-220" data-mp="2labz0dj4he95">
            <ZapIcon className="h-3 w-3 text-amber" aria-hidden="true" data-id="element-221" data-mp="3iwhqvsuf26rj" /> Natychmiastowy dostęp
          </span>
          <span className="flex items-center gap-1.5" data-id="element-222" data-mp="3dx55zdn3v9rl">
            <ShieldCheckIcon className="h-3 w-3 text-amber" aria-hidden="true" data-id="element-223" data-mp="3dvlnrhhw2on6" /> 10 dni gwarancji
          </span>
        </div>
      </div>
    </div>;
}